import { useQuery } from '@tanstack/react-query';

import { WorkspaceDescriptor } from '@synapex/shared2/entities';
import { SnakeIdObj } from '@synapex/tools/typescript';
import { QueryFnData, UseQueryOpts } from '../../engine';
import { useFromLoader } from '../router/loader';
import { all, users, workspaceUsers } from './key-fn';

export const useAll = <SelectedData = QueryFnData<typeof all>>(
  options?: Omit<UseQueryOpts<typeof all, SelectedData>, 'initialData'>,
) => {
  const initialData = useFromLoader();

  return useQuery({
    ...all(),
    staleTime: 1000 * 60 * 60 * 24,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options,
    initialData,
  });
};

export const useUsers = <SelectedData = QueryFnData<typeof users>>(
  params: SnakeIdObj<'advertiser_account'>,
  options?: UseQueryOpts<typeof users, SelectedData>,
) => {
  return useQuery({
    ...users(params),
    ...options,
  });
};

export const useWorkspaceUsers = <
  SelectedData = QueryFnData<typeof workspaceUsers>,
>(
  wd: WorkspaceDescriptor,
  options?: UseQueryOpts<typeof workspaceUsers, SelectedData>,
) => {
  return useQuery({
    ...workspaceUsers(wd),
    ...options,
  });
};
